import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Bootstrap
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Helpers de formulário

class TabTeamTrainingMatterStaffExamsTab extends Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      'dados': [],
      'dados_modal_materias': [],
      'titulo_modal_treinamento': [],
      'modal': false,
    };
    this.selectRow = this.selectRow.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.provas_avulsas)) {
      this.setState({dados: newProps.provas_avulsas});
    }
  }
  selectRow (cell, row) {    
    if (row.span === 'aberta') {
      var span = (
        <span>
          {cell}
        </span>
      );
    } else if (row.span === 'aprovada_c') {
      var span = (
        <span className="label label-success">
          {cell + "(C)"}
        </span>
      );
      
    } else if (row.span === 'reprovada_C') {
      var span = (
        <span className="label label-danger">
          {cell + "(C)"}
        </span>
      );
      
    } else if (row.span === 'aprovada') {
      var span = (
        <span className="label label-success">
          {cell}
        </span>
      );
      
    } else if (row.span === 'reprovada') {
      var span = (
        <span className="label label-danger">
          {cell}
        </span>
      );
      
    } else if (row.span === 'vencida') {
      var span = (
        <span className="label label-default">
          {cell}
        </span>
      );
      
    } else if (row.span === 'contestada') {
      var span = (
        <span className="label label-warning">
          {cell}
        </span>
      );
      
    } 

    return span;
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Provas Avulsas</h3>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há provas cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

    <TableHeaderColumn dataField="prova" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Prova</TableHeaderColumn>
    
    <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Aluno</TableHeaderColumn>

    <TableHeaderColumn dataField="canac" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>C. ANAC</TableHeaderColumn>

    <TableHeaderColumn dataField="team_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>

    <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>

    <TableHeaderColumn dataField="matter" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>

    <TableHeaderColumn dataField="dificuldade" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Dificuldade</TableHeaderColumn>

    <TableHeaderColumn dataField="duration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Duração</TableHeaderColumn>
    <TableHeaderColumn dataField="created_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Gerada em</TableHeaderColumn>

    <TableHeaderColumn dataField="creator" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Gerada em por</TableHeaderColumn>

    <TableHeaderColumn dataField="exam_applied_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Início da Realização</TableHeaderColumn>
    
    <TableHeaderColumn dataField="result" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nota</TableHeaderColumn>

    <TableHeaderColumn dataField="status_str" dataFormat={this.selectRow} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default TabTeamTrainingMatterStaffExamsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/TabTeamTrainingMatterStaffExamsTab.js